function Instruction(props){
    return(
    <div className="font-sans font-normal text-xs/relaxed text-[#727278] small-section">
      {props.instructions}
    </div>
    )
  }

  export {Instruction}
